import { render } from "./LandingButton.vue?vue&type=template&id=2c4c21f0&scoped=true"
import script from "./LandingButton.vue?vue&type=script&lang=js"
export * from "./LandingButton.vue?vue&type=script&lang=js"

import "./LandingButton.vue?vue&type=style&index=0&id=2c4c21f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4c21f0"]])

export default __exports__